import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { NotifimodalPage } from './notifimodal';

@NgModule({
  declarations: [
    NotifimodalPage,
  ],
  imports: [
    IonicPageModule.forChild(NotifimodalPage),
  ],
})
export class NotifimodalPageModule {}



// WEBPACK FOOTER //
// ./src/pages/notifimodal/notifimodal.module.ts